import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="cart-item"
export default class extends Controller {
  static targets = ["quantity"];

  sanitizeQuantityValue(e) {
    this.quantityTarget.value = this.quantityTarget.value
      .replace(/[^0-9.]/g, "")
      .replace(/(\..*?)\..*/g, "$1");
  }
}

// TODO: Improve using this

// export default class extends Controller {
//   static targets = ["quantity"];
//   static values = { maxStock: Number, min: { type: Number, default: 0 } };

//   addToCart(e) {
//     const qty = parseInt(this.quantityTarget.value, 10);
//     if (!qty || qty < 1) {
//       e.preventDefault();
//       this.quantityTarget.value = 1;
//     }
//   }

//   sanitizeQuantityValue(e) {
//     let qty = parseInt(this.quantityTarget.value, 10);
//     if (!qty || qty < 1) qty = 1;
//     if (qty > this.maxStockValue) qty = this.maxStockValue;
//     this.quantityTarget.value = qty;
//   }

//   sanitizeWhileTyping(e) {
//     this.quantityTarget.value = this.quantityTarget.value
//       .replace(/[^0-9.]/g, "")
//       .replace(/(\..*?)\..*/g, "$1");
//   }

//   increaseQuantity(e) {
//     e.preventDefault();
//     this.sanitizeQuantityValue(e);
//     if (parseInt(this.quantityTarget.value, 10) < this.maxStockValue) {
//       this.quantityTarget.value = parseInt(this.quantityTarget.value, 10) + 1;
//     }
//   }

//   decreaseQuantity(e) {
//     e.preventDefault();
//     this.sanitizeQuantityValue(e);
//     if (parseInt(this.quantityTarget.value, 10) > this.minValue) {
//       this.quantityTarget.value = parseInt(this.quantityTarget.value, 10) - 1;
//     }
//   }
// }
